import useQueryParams from 'hooks/useQueryParams';

export const fields = [
  {
    field: 'revenue',
    label: 'Revenue',
    name: 'revenue.value',
    value: '',
  },
  {
    field: 'ltv',
    label: 'LTV Value',
    name: 'ltv.value',
    value: '',
  },
];

export const filterKeys = [
  'user_id',
  'event_id',
  'session_id',
  'ad_ids',
  'adset_ids',
  'campaign_ids',
  'product_ids',
  'ltv',
  'ltv_type',
  'revenue',
  'revenue_type',
  'channels',
  'event_type',
];

const getDefaultFilters = () => {
  const { searchParams } = useQueryParams();

  const {
    user_id,
    event_id,
    session_id,
    ad_ids,
    adset_ids,
    campaign_ids,
    channels,
    event_type,
    product_ids,
  } = searchParams;

  const parseIds = (value) => (value?.length ? value.split(',').map(Number) : []);

  const filters = {
    user_id: user_id || [],
    event_id: event_id || [],
    session_id: session_id || [],
    ad_ids: parseIds(ad_ids),
    adset_ids: parseIds(adset_ids),
    campaign_ids: parseIds(campaign_ids),
    product_ids: parseIds(product_ids),
    channels: channels ? channels.split(',') : [],
    event_type: event_type ? event_type.split(',') : [],
    ...fields.reduce((acc, field) => {
      const value = searchParams[field.field];
      if (value) {
        acc[field.field] = {
          value: searchParams[`${field.field}`],
          type: searchParams[`${field.field}_type`] || 'eq',
        };
      }
      return acc;
    }, {}),
  };

  Object.keys(filters).forEach((key) => {
    if (filters[key] && (Array.isArray(filters[key]) ? filters[key].length === 0 : !filters[key])) {
      delete filters[key];
    }
  });

  return filters;
};

export default getDefaultFilters;
